import React, {useCallback, useEffect, useMemo, useState} from "react";
import {EditLocalStoragePagesData} from "../../../../../../utils/EditLocalStoragePagesData";
import OrderService from "../../../../../../API/orders/orders/organization/OrderService";
import OrderUtil from "../../../../../../utils/orders/OrderUtil";
import {Link} from "react-router-dom";
import AttributeUtil from "../../../../../../utils/orders/AttributeUtil";
import Box from "@mui/material/Box";
import {BreadcrumbsComponent} from "../../../../breadcrumb/BreadcrumbComponent";
import Typography from "@mui/material/Typography";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {ruRU} from "@mui/x-date-pickers/locales";
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from "material-react-table";
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import MenuItem from "@mui/material/MenuItem";
import {UpdateOrderModalConstructor} from "../constructors/OrderConstructorTable";
import {Tooltip} from "@mui/material";
import {constantsErrorMessages} from "../../../../../../Constants";
import ModalAlert from "../../../customer-detales/ModalAlert";
import {calcFilterData} from "../../../../../../utils/common/calcFilterData";
import {DevelopedTableFilterData} from "../../../../../../data/FilterTables/DevelopedTableFilterData";
import DataUtil from "../../../../../../utils/common/DataUtil";
import DateRangeFilter from "../../../../filter/DateRangeFilter";
import {EMPTY_CUSTOMER_NUMBER_FILTER, EMPTY_ORDER_NUMBER_FILTER, EMPTY_CUSTOMER_FILTER, EMPTY_HEADER_FILTER, EMPTY_ATTRIBUTES_FILTER, EMPTY_CONSTRUCTOR_FILTER, EMPTY_TECHNOLOGIST_FILTER, EMPTY_MODEL_FILTER} from "../../../../../../data/OrderStatus";
import OrderFolderNameCell from "../order/OrderFolderNameCell";

const DevelopedTable = () => {

    const [data, setData] = useState([]);
    const [globalFilter, setGlobalFilter] = useState('');
    const [filteredData, setFilteredData] = useState(data)
    const [customerList, setCustomerList] = useState([]);
    const [constructorList, setConstructorList] = useState([]);
    const [technologistList, setTechnologistList] = useState([]);
    const [nameList, setNameList] = useState([]);
    const [modelList, setModelList] = useState([]);
    const [attributeList, setAttributeList] = useState([]);
    const [numberList, setNumberList] = useState([]);
    const [numberCustomerList, setNumberCustomerList] = useState([]);
    const [updateModalOpen, setUpdateModalOpen] = useState(false);
    const [currentEditRowData, setCurrentEditRowData] = useState(null);
    const [dateOfConstructorDocumentation, setDateOfConstructorDocumentationOfReceipt] = useState(null);
    const [dateOfTechnicalDocumentation, setDateOfTechnicalDocumentation] = useState(null);
    const [alertData, setAlertData] = useState({});
    const [currentEditRowId, setCurrentEditRowId] = useState(null);
    const [change, setChange] = useState(null);
    const [columnsFilter, setColumnsFilter] = useState([]);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const [showColumnFilters, setShowColumnFilters] = useState(false)

    const handleShowColumnFilters = () => {
        setShowColumnFilters(!showColumnFilters)
        if (showColumnFilters) {
            handleSearchQuery([], data, null, true)
        }
    }
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`organization/constructors/developed`, "pageSize", nextState.pageSize)
        }
    }
    const handleSearchQuery = (searchQuery, prevData, pageSize, isColumnFilters) => {
        const newColumnsFilter = isColumnFilters ? searchQuery : columnsFilter
        const newGlobalFilter = isColumnFilters ? globalFilter : searchQuery || ""

        const data = [...prevData]
        const globalFilterData = newGlobalFilter ? calcFilterData(data, newGlobalFilter, DevelopedTableFilterData) : data
        const newData = newColumnsFilter.reduce((accumulator, currentValue) => {
            return calcFilterData(accumulator, currentValue?.value, [DevelopedTableFilterData.find(el => el.idFromColumnFilter === currentValue.id)])
        }, globalFilterData);

        setFilteredData(newData)

        tableOptionsHandle({
            ...tableOptions,
            totalElements: newData.length,
            pageSize: pageSize ? pageSize : tableOptions?.pageSize
        })

        if (isColumnFilters) {
            setColumnsFilter(searchQuery)
        } else {
            setGlobalFilter(searchQuery || "")
            if (searchQuery !== globalFilter) {
                EditLocalStoragePagesData(`organization/constructors/developed`, "searchQuery", searchQuery)
            }
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`organization/constructors/developed`]?.pageSize
        const searchQuery = pagesData[`organization/constructors/developed`]?.searchQuery

        return {searchQuery, pageSize}
    }
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const setLists = (data) => {
        setCustomerList(DataUtil.getListField(data, 'customerName', EMPTY_CUSTOMER_FILTER));
        setNameList(DataUtil.getListChildField(data, 'header', 'name', EMPTY_HEADER_FILTER));
        setConstructorList(DataUtil.getListChildField(data, 'constructor', 'name', EMPTY_CONSTRUCTOR_FILTER));
        setTechnologistList(DataUtil.getListChildField(data, 'technologist', 'name', EMPTY_TECHNOLOGIST_FILTER));
        setAttributeList(OrderUtil.getStatuses(data, 'attributes', EMPTY_ATTRIBUTES_FILTER));
        setModelList(OrderUtil.getEstimateModuleNamesList(data, EMPTY_MODEL_FILTER));
        setNumberList(DataUtil.getListField(data, 'number', EMPTY_ORDER_NUMBER_FILTER));
        setNumberCustomerList(DataUtil.getListField(data, 'numberCustomer', EMPTY_CUSTOMER_NUMBER_FILTER));
    }

    useEffect(() => {
        const {searchQuery, pageSize} = getStartPageSize()
        OrderService.getOrdersConstructorsDone().then(function (response) {
            let data = response.data
            setData(data);
            handleSearchQuery(searchQuery, data, pageSize)
            setLists(response.data)
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, [change]);

    const handleUpdate = (row, values) => {
        data[row[currentEditRowId]] = values;
        const newData = [...data]
        setData(newData)
        handleSearchQuery(globalFilter, newData)
        setLists(newData)
    };

    const handleUpdateModel = useCallback(
        (row) => {
            setCurrentEditRowData(row);
            setDateOfConstructorDocumentationOfReceipt(row.dateOfConstructorDocumentation);
            setDateOfTechnicalDocumentation(row.dateOfTechnicalDocumentation)
            setCurrentEditRowId(row.id);
            setUpdateModalOpen(true);
        },
        [data, currentEditRowData, setCurrentEditRowData],
    );

    const columns = useMemo(
        () => [
            {
                id: 'number',
                header: 'Номер заказа',
                accessorKey: 'number',
                filterVariant: 'multi-select',
                filterSelectOptions: numberList,
                enableEditing: false,
                maxSize: 23,
                minSize: 35,
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по № заказа',
                    sx: {width: '200px'},
                },
                Cell: ({cell, row}) => {
                    const headerValue = row.original.header;
                    let header = null
                    if (headerValue !== null) {
                        header = headerValue.id;
                    }
                    return (
                        <OrderFolderNameCell order={row.original}>
                            <Tooltip arrow placement="bottom" title={row.original.number}>
                                <Box
                                    sx={{
                                        width: "130px",
                                        overflow: "clip",
                                        textOverflow: "ellipsis"
                                    }}
                                >
                                    <Link
                                        to={'/organization/constructors/' + row.original.id + '/' + encodeURIComponent(cell.getValue()) + '/' + header + '/' + row.original.year}
                                    >
                                        {cell.getValue() === null ? 'Не занумерован' : cell.getValue()}
                                    </Link>
                                </Box>
                            </Tooltip>
                        </OrderFolderNameCell>
                    );
                },
            },
            {
                id: 'numberCustomer',
                header: 'Номер заказчика',
                accessorKey: 'numberCustomer',
                filterVariant: 'multi-select',
                filterSelectOptions: numberCustomerList,
                maxSize: 23,
                minSize: 35,
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по № заказчика',
                    sx: {width: '200px'},
                },
            },
            {
                id: 'customerName',
                header: 'Заказчик',
                accessorKey: 'customerName',
                enableStickyHeader: true,
                enableStickyFooter: true,
                enableGrouping: true,
                enableEditing: false,
                filterVariant: 'multi-select',
                filterSelectOptions: customerList,
                minSize: 200,
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по заказчик',
                    sx: {
                        width: '230px',
                    },
                }
            },
            {
                id: "header",
                header: 'Наименование',
                accessorFn: (row) => row.header?.name,
                filterVariant: 'multi-select',
                filterSelectOptions: nameList,
                enableGrouping: true,
                enableEditing: false,
                minSize: 15,
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по наименование',
                    sx: {
                        width: '200px',
                    },
                }
            },
            {
                id: 'models',
                header: 'Модели',
                accessorFn: (row) => OrderUtil.getEstimateModuleNames(row).join(', '),
                filterVariant: 'multi-select',
                filterSelectOptions: modelList,
                enableGrouping: true,
                enableEditing: false,
                size: Math.max(
                    80,
                    ...['Модели', ...(modelList || []).filter((name) => name !== EMPTY_MODEL_FILTER)]
                        .map((name) => String(name).length * 9)
                ),
                Cell: ({row}) => {
                    const names = OrderUtil.getEstimateModuleNames(row.original);
                    if (!names.length) {
                        return null;
                    }
                    return (
                        <Box sx={{display: 'flex', flexDirection: 'column', whiteSpace: 'nowrap'}}>
                            {names.map((name, index) => (
                                <Box key={`${name}-${index}`}>{name}</Box>
                            ))}
                        </Box>
                    );
                },
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по модели',
                    sx: {
                        minWidth: '200px',
                        width: 'auto',
                    },
                }
            },
            {
                id: 'attributes',
                header: 'Атрибуты',
                accessorKey: 'attributes',
                filterVariant: 'multi-select',
                filterSelectOptions: attributeList,
                filterFn: (row, id, filterValue) => {
                    return OrderUtil.checkStatus(row.getValue(id), filterValue)
                },
                minSize: 20,
                enableEditing: false,
                Cell: ({cell, row}) => (
                    <Link
                        to={'/organization/orders/set-attribute/' + row.original.id + '/' + encodeURIComponent(row.original.number) + '/' + row.original.header.id}
                    >{row.original.attributes.length === 0 ? 'Не устанволен' : AttributeUtil.convertAttributes(cell.getValue())}</Link>
                ),
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по атрибуты',
                    sx: {
                        width: '160px',
                    },
                }

            },
            {
                accessorFn: (row) => {
                    if (row.dateOfPlannedProduction === null) {
                    } else {
                        return new Date(row.dateOfPlannedProduction)
                    }
                },
                id: 'dateOfPlannedProduction',
                header: 'Плановая дата произодства',
                sortingFn: 'datetime',
                minSize: 150,
                enableEditing: false,
                Cell: ({cell}) => {
                    if (cell.getValue() !== undefined) {
                        return cell.getValue().toLocaleDateString('en-GB');
                    }
                },
                Filter: ({column}) => <DateRangeFilter
                    column={column}
                />,
            },
            {
                id: "constructor",
                header: 'Констуктор',
                accessorKey: 'constructor.name',
                enableStickyHeader: true,
                enableStickyFooter: true,
                enableGrouping: true,
                filterVariant: 'multi-select',
                filterSelectOptions: constructorList,
                maxSize: 100,
                minSize: 100,
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по конструктор',
                    sx: {
                        width: '160px',
                    },
                }
            },
            {
                accessorFn: (row) => {
                    if (row.dateOfConstructorDocumentation === null) {
                    } else {
                        return new Date(row.dateOfConstructorDocumentation)
                    }
                },
                id: 'dateOfConstructorDocumentation',
                header: 'Дата тех. документации конструктор',
                sortingFn: 'datetime',
                minSize: 250,
                Cell: ({cell}) => {
                    if (cell.getValue() !== undefined) {
                        return cell.getValue().toLocaleDateString('en-GB');
                    }
                },
                Filter: ({column}) => <DateRangeFilter
                    column={column}
                />,
            },
            {
                id: 'technologist',
                header: 'Технолог',
                accessorKey: 'technologist.name',
                enableStickyHeader: true,
                enableStickyFooter: true,
                enableGrouping: true,
                filterVariant: 'multi-select',
                filterSelectOptions: technologistList,
                maxSize: 20,
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по технолог',
                    sx: {
                        width: '160px',
                    },
                }
            },
            {
                accessorFn: (row) => {
                    if (row.dateOfTechnicalDocumentation === null) {
                    } else {
                        return new Date(row.dateOfTechnicalDocumentation)
                    }
                },
                id: 'dateOfTechnicalDocumentation',
                header: 'Дата тех. документации технолог',
                sortingFn: 'datetime',
                minSize: 250,
                Cell: ({cell}) => {
                    if (cell.getValue() !== undefined) {
                        return cell.getValue().toLocaleDateString('en-GB');
                    }
                },
                Filter: ({column}) => <DateRangeFilter
                    column={column}
                />,
            },
            {
                header: 'id',
                accessorKey: 'id',
                enableHiding: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableColumnFilter: false,
                enableEditing: false,
            },
        ],
        [data, setData, filteredData, customerList, nameList, modelList, attributeList, constructorList, technologistList, numberList, numberCustomerList],
    );

    const menuItem = [
        {type: "edit", text: "Редактировать", handler: handleUpdateModel}]

    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={"Разработано"}
                path={[
                    {name: "Главная", href: "/"},
                    {name: "Проектирование", href: "/organization/constructors"},
                ]}/>
            <Box sx={{maxWidth: "2500px", display: "flex", flexDirection: "column", gap: "32px"}}>
                <Box sx={{display: "flex", flexDirection: "column"}}>
                    <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                        Разработано
                    </Typography>
                </Box>
                <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    adapterLocale='ru'
                    localeText={ruRU.components.MuiLocalizationProvider.defaultProps.localeText}>
                    <MaterialReactTable
                        muiTopToolbarProps={{
                            sx: {
                                "& .MuiBox-root": {
                                    padding: 0
                                }
                            }
                        }}
                        muiTableBodyCellProps={{
                            sx: {
                                p: '0px 0px 0px 10px',
                                m: '0px 0px 0px 0px',
                                border: "none",
                                "&:not(:last-of-type)": {
                                    borderRight: '1px solid #EAEBEA',

                                },
                                "&:first-of-type": {
                                    padding: 0,
                                    width: "50px",
                                    height: "36px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    color: (theme) => theme.palette.text.light,
                                    "& .MuiButtonBase-root": {
                                        borderRadius: "4px",
                                        width: "24px",
                                        height: "24px",
                                        opacity: 1,
                                        margin: 0,
                                        padding: 0,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.stroke,
                                        }
                                    }
                                },
                                "& a": {
                                    color: "#006CCC",
                                    textDecoration: "none",
                                    "&:hover": {
                                        textDecoration: "underline"
                                    }

                                }
                            },
                        }}
                        muiTableHeadCellProps={{
                            sx: {
                                border: '1px solid #EAEBEA',
                                backgroundColor: "#F5F6FA",
                                padding: "10px",
                                paddingBottom: " 0.2rem",
                                paddingTop: "0.2rem",
                                "&:first-of-type .Mui-TableHeadCell-Content-Wrapper": {
                                    "minWidth": "100%"
                                },
                                "& .MuiCollapse-root .MuiSelect-select": {
                                    padding: "0 !important",
                                    "& .MuiChip-label": {
                                        paddingLeft: "5px",
                                        paddingRight: "5px",
                                    }
                                }
                            },
                        }}
                        muiTableBodyRowProps={({row}) => {
                            return ({
                                sx: () => ({
                                    height: '36px',
                                    backgroundColor: "white",
                                    "&:hover& td:after": {
                                        display: "none",
                                    },
                                    "&:hover": {
                                        "& td:after": {
                                            display: "none",
                                        },
                                    },
                                    '&:nth-of-type(even)': {
                                        backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                    },
                                })
                            })
                        }}

                        muiSearchTextFieldProps={{
                            placeholder: `Поиск`,
                            sx: {
                                paddingTop: "5px",
                                paddingBottom: "0px",
                                "& .MuiCollapse-root": {
                                    borderRadius: '12px',
                                    height: 40, width: 290,
                                    "& .MuiSvgIcon-root": {
                                        color: "#737478"
                                    },
                                    '& .MuiOutlinedInput-input': {
                                        padding: 0
                                    }
                                }
                            },
                            variant: 'outlined',
                        }}
                        displayColumnDefOptions={{
                            'mrt-row-actions': {
                                header: "",
                                size: 3,
                                minSize: 3,
                                grow: false,
                            },
                        }}
                        columns={columns}
                        data={filteredData}
                        onPaginationChange={(updater) => {
                            tableOptionsHandle(updater(tableOptions));
                        }}
                        onGlobalFilterChange={(value) => {
                            handleSearchQuery(value, data, null)
                        }}
                        onColumnFiltersChange={(updater) => {
                            handleSearchQuery(updater(columnsFilter), data, null, true)
                        }}
                        onShowColumnFiltersChange={handleShowColumnFilters}
                        state={{
                            showColumnFilters: showColumnFilters,
                            columnFilters: columnsFilter,
                            globalFilter: globalFilter,
                            showGlobalFilter: true,
                            pagination: tableOptions,
                        }}
                        manualFiltering={true}
                        rowCount={tableOptions.totalElements}
                        initialState={{
                            columnVisibility: {
                                id: false,
                            },
                        }}
                        muiToolbarAlertBannerChipProps={{color: 'primary'}}
                        localization={MRT_Localization_RU}
                        enableRowActions={true}
                        enableToolbarInternalActions={false}
                        selectAllMode={"all"}
                        renderTopToolbar={({table}) => {
                            return <Box sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "7px",
                                backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                            }}>
                                <MRT_ToolbarAlertBanner table={table}/>
                                <Box sx={{display: "flex"}}>
                                    <MRT_ToggleFiltersButton table={table}/>
                                    <MRT_GlobalFilterTextField table={table}/>
                                </Box>
                            </Box>
                        }}
                        muiToolbarAlertBannerProps={{
                            sx: {
                                backgroundColor: (theme) => theme.palette.primary.light,
                                "& .MuiStack-root": {
                                    padding: 0,
                                },
                            }
                        }}
                        renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                            return <MenuItem
                                key={el.type}
                                onClick={() => {
                                    el.handler(row.original)
                                    closeMenu();
                                }}
                                sx={{
                                    margin: "0 8px",
                                    borderRadius: "4px",
                                    "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                                }}
                            >
                                {el.text}
                            </MenuItem>
                        })}
                    />
                </LocalizationProvider>
            </Box>
            <UpdateOrderModalConstructor
                open={updateModalOpen}
                onClose={() => setUpdateModalOpen(false)}
                onSubmit={handleUpdate}
                values={currentEditRowData}
                currentEditRowId={currentEditRowId}
                change={change}
                setChange={setChange}
                setValues={setCurrentEditRowData}
                dateOfConstructorDocumentation={dateOfConstructorDocumentation}
                setDateOfConstructorDocumentationOfReceipt={setDateOfConstructorDocumentationOfReceipt}
                dateOfTechnicalDocumentation={dateOfTechnicalDocumentation}
                setDateOfTechnicalDocumentation={setDateOfTechnicalDocumentation}
                handleModalAlert={handleModalAlert}
            />
            <ModalAlert
                data={alertData}
                onClose={() => setAlertData((alert) => ({...alert, open: false}))}
            />
        </Box>
    );
};
export default DevelopedTable